import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface EarlyAccessGateState {
  /**
   * True while the early-access gate overlay (the modal card + its shell) is the
   * surface on screen. Published by the gate so `AppThemeProvider` can force the
   * dark theme for the duration the modal is shown, and only then. The routes
   * the gate passes through to (the marketing landing, the self-gated
   * `/rewards`) are NOT covered, so they keep their own light/dark behaviour.
   */
  overlayVisible: boolean;
  setOverlayVisible: (visible: boolean) => void;
}

export const useEarlyAccessGateStore: UseBoundStore<StoreApi<EarlyAccessGateState>> =
  createTrackedStore<EarlyAccessGateState>('useEarlyAccessGateStore')((set) => ({
    overlayVisible: false,
    setOverlayVisible: (visible: boolean): void => set({ overlayVisible: visible }),
  }));
